import { render, staticRenderFns } from "./DeleteStorageModal.vue?vue&type=template&id=c9916dce&scoped=true&"
import script from "./DeleteStorageModal.vue?vue&type=script&lang=js&"
export * from "./DeleteStorageModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteStorageModal.vue?vue&type=style&index=0&id=c9916dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9916dce",
  null
  
)

export default component.exports